<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>cropspot+ Abo kündigen</span>
		</template>
		<template v-slot:content>
			<div class="px-6 py-6">
				<div class="px-6">
					<p class="mb-5">Möchten Sie Ihr cropspot+ Abo wirklich kündigen?</p>
					<p class="mb-3">Nach der Kündigung behalten Sie bis zum Ende der aktuellen Laufzeit Zugriff auf Ihre Premium-Funktionen. Ihr Abo wird danach nicht automatisch verlängert und es entstehen keine weiteren Kosten.</p>

					<div class="flex items-center flex-col text-green">
						<font-awesome-icon
							icon="fa-light fa-lightbulb-exclamation-on"
							class="text-4xl my-6"
						/>
						<p class="text-green-600 max-w-[80%] text-center">Mit Ihrem Freihandels&shy;kontingent von 150 Tonnen können Sie die Kosten für Ihr cropspot+ Abo wieder ausgleichen. Nutzen Sie Ihr Freihandels&shy;kontingent aktiv und holen Sie das Maximum aus cropspot+ heraus!</p>
					</div>
				</div>
			</div>
			<div class="bg-gray-100 p-6">
				<div class="flex justify-end px-6">
					<ui-button
						v-on:click="submitForm()"
						label="Jetzt kündigen"
					/>
				</div>
			</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import axios from "axios";
import toast from '../../services/toast';

// todo disable button while executing
export default {
	props: {
		id: {
			type: Number,
			default: null
		}
	},
	methods: {
		async submitForm() {

			const params = {};
			params["id"] = this.id;

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(this.$route("premium.terminate", params));

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");

			this.$toast.success('Ihre Kündigung war erfolgreich!');
		},
		onError(error) {
			const errors = error.response.data.errors;
			this.$bus.$emit("form:invalid", errors);
		},
	},
};
</script>
